import React from "react";
import { Link } from "react-router-dom";
import { ArrowRightIcon as ArrowRight } from "@phosphor-icons/react";

/**
 * Inline companion link rendered next to mailto: addresses on legal pages.
 * Routes the visitor into the public contact form pre-filled with subject
 * + topic so the message lands in the Admin Inbox.
 *
 * Usage:
 *   <ContactFormLink topic="privacy" subject="Privacy inquiry" />
 */
export default function ContactFormLink({ topic, subject, label }) {
  const params = new URLSearchParams();
  if (topic) params.set("topic", topic);
  if (subject) params.set("subject", subject);
  const href = `/contact?${params.toString()}`;
  return (
    <Link
      to={href}
      data-testid={`contact-form-link-${topic || "general"}`}
      className="inline-flex items-center gap-1 text-xs font-semibold text-crimson hover:text-ink underline underline-offset-2 ml-2 whitespace-nowrap"
    >
      {label || "or use our contact form"}
      <ArrowRight size={12} weight="bold" />
    </Link>
  );
}
